import { type IContent } from "@kunduz/data-access-cms-api";
import { QuickNavigation, blue } from "@kunduz/ui-components";
import React, { ReactElement } from "react";
import { getCmsIcon } from "../static/iconMappings";
import { trackEventNext } from "@kunduz/utility-analytics";

export const QuickNavigationWithContext = (props: Props): ReactElement => {
  const handleClick = (label: string) => {
    trackEventNext({
      event: "Quick Navigation Item Clicked",
      label,
    });
  };

  return (
    <QuickNavigation
      items={props.data.items.map((x) => {
        const Icon = getCmsIcon(x.icon);
        return {
          label: x.label,
          href: x.url,
          icon: <Icon color={blue[600]} />,
          onClick: () => handleClick(x.label),
        };
      })}
    />
  );
};

interface Props {
  data: IContent.QuickNavigationComponentData;
}
